import { SET_THEME } from './actions'

const initialState = {
  current: 'default'
}

const themeReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_THEME:
      return {
        ...state,
        current: action.payload
      }
    default:
      return state
  }
}

export default themeReducer
